import {
  FETCH_TICKETS_REQUEST,
  FETCH_TICKETS_SUCCESS,
  FETCH_TICKETS_FAILURE,
  FETCH_TICKETS_RESET,
} from '../constant/fetchTicketsConstant';

const initialState = {
  loading: false,
  tickets: [], 
  error: null,
};

export const fetchTicketReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TICKETS_REQUEST:
      return {
        ...state,
        loading: true,
        tickets: null,
        error: null,
      };
    case FETCH_TICKETS_SUCCESS:
      return {
        ...state,
        loading: false,
        tickets: action.payload,
      };
    case FETCH_TICKETS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case FETCH_TICKETS_RESET:
      return { ...initialState }; // Reset to initial state
    default:
      return state;
  }
};
